module.exports = __webpack_public_path__ + "img/aside-tit1.ce20d306.png";